import React from "react";
import { Box } from "@mui/material";
import { useGetAllowedValues, useSites, useGetConfigParameter, useAllCollectors, useUtilityBillsYears } from "hooks";
import { DashboardTabs } from "components";
import { TARGETS_PAGE } from "pages/authenticated/accelerate/targets/consts";
import { isPageEnabled } from "utils";
import { TabName, SubTabName, TabComponent } from "./types";
import { MainTab, DataReadinessTab, TargetsTab, IntensityTab } from "./components";

export const DashboardPageV2 = () => {

  const { data: allowedValues } = useGetAllowedValues();
  const { data: sitesData } = useSites();
  const { data: configParameter } = useGetConfigParameter();
  const { data: collectorsData } = useAllCollectors();
  const { data: availableYears } = useUtilityBillsYears();

  const targetsEnabled = isPageEnabled(TARGETS_PAGE, configParameter);

  const tabs: TabName[] = [
    "GHG Emissions", "Consumption", "Financials", "Intensity", "Data Readiness",
    ...(targetsEnabled ? ["Targets" as TabName] : []),
  ];
  const initialTab: TabName = tabs[0];

  const subTabs: Partial<Record<TabName, SubTabName[]>> = {
    "GHG Emissions": ["Location", "Market"],
    "Consumption": ["Overview", "Electricity", "Natural Gas", "Water", "Sewer"],
    "Financials": ["Overview", "Electricity", "Natural Gas", "Water", "Sewer"],
  };

  const standaloneContent: Partial<Record<TabName, JSX.Element>> = {
    "Intensity": <IntensityTab />,
    "Data Readiness": <DataReadinessTab />,
    "Targets": <TargetsTab />,
  };

  const fiscalYears = availableYears ? availableYears.map((yearItem: any) => `${yearItem}`) : [];

  const allTabs: TabComponent[] = tabs.map((tab) => {
    const standalone = standaloneContent[tab];
    if (standalone) {
      return { label: tab, content: standalone };
    }

    return {
      label: tab,
      content: <MainTab
        currentMainTab={tab}
        tabs={subTabs[tab] ?? []}
        allowedValues={allowedValues}
        sitesData={sitesData}
        configParameter={configParameter}
        collectorsData={collectorsData}
        fiscalYears={fiscalYears}
      />,
    };
  })

  return (
    <Box sx={{ ml: 3 }}>
      <DashboardTabs intensity tabs={allTabs} selectedBtnOption={initialTab} dashboard />
    </Box>
  );
}
